import { React, useEffect, useState, Fragment, useCallback } from "react";

import cogoToast from "cogo-toast";
import { SUCCESS_RESULT, TEMPLATES_URL, ENDPOINTS, LOCAL_PATHS } from "../../Constants";
import { getTemplateByName, genericPost } from "../../services/Api";

import { Spinner } from "reactstrap";
import { useHistory, Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, Table, Button } from "reactstrap";
import * as SurveyCore from "survey-core"; 
import { Survey } from 'survey-react-ui'; 
import "survey-core/defaultV2.min.css";
import "survey-creator-core/survey-creator-core.min.css";
import 'survey-core/modern.min.css';
import "./styles.css";


const CreateProject = (props) => {
    // Support both props.location.data (old) and props.location.state.data (new) for backward compatibility
    let incomingData = props.location?.state?.data || props.location?.data || props.location?.state;
    // console.log("Data is here>><<:: " + JSON.stringify(incomingData?.id));
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const [template, setTemplate] = useState(null);
    // const [formParamId, setFormParamId] = useState(null);
    const [formData, setFormData] = useState(null);
 
    SurveyCore.StylesManager.applyTheme("modern");
    // const [surveyModel, setSurveyModel] = useState(new Model(template));
    // let rest = {
    //     "project_name": "Desert Locust Emergency Response Project - Somaliland",
    //     "startdate": "2023-01-01",
    //     "alias": "DLEP",
    //     "enddate": "2023-12-31",
    //     "project_description": "Desert Locust breeding is ongoing in Somaliland. An estimatedÿ 100,000 in coastal regions were occupied by swarms and almost 1,087,264 people living in those areas were affected. So far, the Locust population has been confined to rangeland/grasslands (in the north-Somaliland). These swarms will be at their most destructive stage and pose a very severe risk to Gu season food and fodder production. In response to the prevailing locust situations, Islamic relief Somalia proposes a project which will reduce the impact as well as protect the livelihoods of most affected population in Somaliland. In line with this, the project will deliver locust protection mechanisms, livelihood protection and capacity building to local authorities in effectively responding to the desert locust outbreak. 1200 individuals will be reached in Bulahar district of Sahil Region. The project will also target households where the primary beneficiary is lacking capacity to afford 3 daily meals, water and service levels putting the health and nutritional status of people at risk.",
    //     "project_code": "SO020_00230",
    //     "project_sectors": [
    //         "z54ed270-2b91-11ed-b6ab-0a9ea65235cz",
    //         "z45f584f-9ca3-463c-8309-1ed6b463582z"
    //     ]
    // };
    let surveyModel = new SurveyCore.Model(template);
    useEffect(() => {
        if (incomingData !== null && incomingData !== undefined) {
            // Handle project_sectors if it's a string that needs parsing
            if (incomingData.project_sectors && typeof incomingData.project_sectors === 'string') {
                incomingData.project_sectors = JSON.parse(incomingData.project_sectors);
            }
            // setFormParamId(incomingData.id);
            setFormData({
                "id": incomingData.id,
                "project_name": incomingData.project_name,
                "startdate": incomingData.startdate,
                "alias": incomingData.alias,
                "enddate": incomingData.enddate,
                "project_description": incomingData.project_description,
                "project_code": incomingData.project_code,
                "project_sectors": incomingData.project_sectors
            });
        }
        getProjectTemplate();
        surveyModel = new SurveyCore.Model(template);
        // surveyModel.data=rest;//JSON.stringify(rest); 
        // surveyModel.data = {
        //     "project_name": "Desert Locust Emergency Response Project - Somaliland",
        //     "startdate": "2023-01-01",
        //     "alias": "DLEP",
        //     "enddate": "2023-12-31",
        //     "project_description": "Desert Locust breeding is ongoing in Somaliland. An estimatedÿ 100,000 in coastal regions were occupied by swarms and almost 1,087,264 people living in those areas were affected. So far, the Locust population has been confined to rangeland/grasslands (in the north-Somaliland). These swarms will be at their most destructive stage and pose a very severe risk to Gu season food and fodder production. In response to the prevailing locust situations, Islamic relief Somalia proposes a project which will reduce the impact as well as protect the livelihoods of most affected population in Somaliland. In line with this, the project will deliver locust protection mechanisms, livelihood protection and capacity building to local authorities in effectively responding to the desert locust outbreak. 1200 individuals will be reached in Bulahar district of Sahil Region. The project will also target households where the primary beneficiary is lacking capacity to afford 3 daily meals, water and service levels putting the health and nutritional status of people at risk.",
        //     "project_code": "SO020_00230",
        //     "project_sectors": [
        //         "z54ed270-2b91-11ed-b6ab-0a9ea65235cz",
        //         "z45f584f-9ca3-463c-8309-1ed6b463582z"
        //     ]
        // };

        return () => { };
    }, []);
    //SAVE THE FORM DATA
    // const surveyCompletes = useCallback((sender) => {
    //     // console.log("-------------DATA-----------------");
    //     console.log(JSON.stringify(sender.data));

    // });
    const surveyComplete = useCallback((sender) => {
        // console.log(JSON.stringify(sender.data));
        setIsLoading(true);
        // formData = sender.data;
        // if (formParamId !== null && formParamId !== "")
        //     formData["id"] = formParamId;
        
        let dataToSend=sender.data;
        
        console.log(JSON.stringify(dataToSend));
        setFormData({ 
            "project_name": dataToSend.project_name,
            "startdate": dataToSend.startdate,
            "alias": dataToSend.alias,
            "enddate": dataToSend.enddate,
            "project_description": dataToSend.project_description,
            "project_code": dataToSend.project_code,
            "project_sectors": dataToSend.project_sectors
        });
        // formData = sender.data;
        if (incomingData !== null && incomingData !== undefined) {
            dataToSend["id"] = incomingData.id;
        }
        // console.log("Data bbbb<<<<");
        // console.log(JSON.stringify(dataToSend));
        genericPost(ENDPOINTS.CREATE_PROJECT, dataToSend)
            .then((response) => {
                setIsLoading(false);
                if (response.status == 200) {
                    if (response.data.status == SUCCESS_RESULT) {
                        cogoToast.success(response.data.message, {
                            hideAfter: 5,
                        });
                        history.push({
                            pathname: LOCAL_PATHS.LIST_PROJECTS,
                            state: {
                                data: "",
                            },
                        });
                    } else {
                        cogoToast.error(response.data.message, {
                            hideAfter: 5,
                        });
                    }
                }
            })
            .catch((err) => {
                setIsLoading(false);
                console.log(err);
                cogoToast.error("Something went wrong, please Try again. " + err, {
                    hideAfter: 5,
                });
            });
    }, []);



    const surveyCss = {
        actionBar: {
            root: "sd-action-bar custom-actionbar-root",
        },
        navigation: {
            complete: "sd-btn--action sd-navigation__complete-btn custom-btn",
            prev: "sd-navigation__prev-btn custom-btn",
            next: "sd-navigation__next-btn custom-btn",
            start: "sd-navigation__start-btn custom-btn",
            preview: "sd-navigation__preview-btn custom-btn",
        }
    }
    surveyModel.onComplete.add(surveyComplete);
    const getProjectTemplate = () => {
        setIsLoading(true);

        getTemplateByName({ template_name: TEMPLATES_URL.CREATE_PROJECT })
            .then((response) => {

                setIsLoading(false);

                if (response.status == 200) {



                    if (response.data.status == SUCCESS_RESULT) {
                        // var response = res.data;

                        cogoToast.success("Loaded the survey", {
                            hideAfter: 5,
                        });
                        setTemplate(response.data.data[0].template);
                        // surveyModel.data = incomingData;
                        // setSurveyModel(new Model(template));
                        // setTemplate(JSON.stringify(response.data.data[0].template));

                    } else {
                        cogoToast.error(response.data.message, {
                            hideAfter: 5,
                        });
                    }
                }
            })
            .catch((err) => {
                setIsLoading(false);
                console.log(err);
                cogoToast.error("Something went wrong, please Try again. ", {
                    hideAfter: 5,
                });
            });
    };



    return (
        <div style={{ backgroundColor: 'white', minHeight: '100vh', padding: '20px' }}>
            {/* <h1>CREATE PROJECT.</h1> */}
            <Breadcrumb className="ms-1">
                <BreadcrumbItem>
                    <Link to="/ebms"> EBMS </Link>
                </BreadcrumbItem>
                <BreadcrumbItem >
                    <Link to="/projects"> PROJECTS </Link>
                </BreadcrumbItem>
                <BreadcrumbItem active>
                    <Link to="/"> CREATE PROJECT </Link>
                </BreadcrumbItem>
            </Breadcrumb>

            <div className="d-flex justify-content-center my-1">
                {isLoading && <Spinner />}
            </div>

            <div className="ag-theme-alpine responsive margin20" style={{ backgroundColor: 'white' }}>

                <Survey model={surveyModel} css={surveyCss} data={formData} />
            </div>
        </div>);
    // return ( <Survey model={surveyModel} />);
};
export default CreateProject;